module.exports = __webpack_public_path__ + "img/kefu.727db173.png";